import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { Customer } from 'src/app/interfaces/customer';
import { DisplayPaymentDetails } from 'src/app/interfaces/display-payment-details';
import { IInvoiceDetail } from 'src/app/interfaces/i-invoice-detail';
import { IPayment } from 'src/app/interfaces/i-payment';
import { IInvoice } from 'src/app/interfaces/iinvoice';
import { PaymentMethodAch } from 'src/app/interfaces/payment-method-ach';
import { PaymentMethodCc } from 'src/app/interfaces/payment-method-cc';
import { PaymentMethods } from 'src/app/interfaces/payment-methods';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfigDataService } from 'src/app/services/config-data.service';
import { GeneralService } from 'src/app/services/general.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-activity',
    templateUrl: './activity.component.html',
    styleUrls: ['./activity.component.scss'],
    standalone: false
})
export class ActivityComponent {
     userProfile?: UserProfile;
     customer?: Customer;
     companyType: string = '';

     invoices: IInvoice[] = [];
     selectedInvoice: IInvoice | null = null;
     totalBalance: number = 0;
     useMockData: boolean = false;
     isLoading = false;
     isDownloading = false;
     isPaying = false;
     creatingPayment: boolean = false;
     paymentMethod: string = "";
     paymentAmount: string = "";
     paymentAmountMax: number = 0.0;
     paymentMethods: any = {};
     activeMethods: any = {};
     displayMethods: { isCC: boolean, accountNumber: string, methodId: number, isDefault: boolean }[] = [];
     selectedMethodId: number = 0;
     selectedInvoicesIds: string = "";
     displayConfirmPay: boolean = false;
     showPaymentSuccess: number = 0;
     showPaymentError: number = 0;

     paymentRequest: IPayment | null = null;
     invoicesToPay: IInvoice[] = [];
     displayPaymentDetails: DisplayPaymentDetails[] = [];
     totalDueForBill: number = 0;
     totalAmountPaying = 0;
     balance: number = 0;
     cardSurcharge: number = 0;
     paymentId: number = 0;
     showPayment: boolean = false;
     showPayAll: boolean = false;
     parseFloat_ = parseFloat;
     paymentInfo!: FormGroup;

     @ViewChild('paymentSuccessModal') successRef!: TemplateRef<any> | undefined;
     @ViewChild('paymentErrorModal') errorRef!: TemplateRef<any> | undefined;
     @ViewChild('ConfirmPayModal') confirmPayRef!: TemplateRef<any> | undefined;

     constructor(public generalService: GeneralService,
          public paymentsService: PaymentsService, public invoiceService: InvoiceService,
          public configDataService: ConfigDataService,
          private router: Router, private modalService: NgbModal,private elementRef: ElementRef,
          private authenticationService: AuthenticationService) {
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          const invoicePromise = invoiceService.getInvoices();
          invoicePromise.subscribe((result: IInvoice[] | any) => this.loadInvoices(result));

          this.paymentsService.getBillingAccounts().subscribe((result: PaymentMethods | any) => {
               this.loadBillingAccounts(result)
          });

          this.configDataService.getConfig("CardSurcharge").then((result: number | any) => {
               this.cardSurcharge = result;
          });
          this.configDataService.getConfig("ShowPayment").then((result: number | any) => {
               this.showPayment = result;
          });

     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);
          this.isLoading = true;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     loadInvoices(invoices: IInvoice[] | any) {
          if (invoices) {
               this.isLoading = false;
               invoices.sort((a: IInvoice, b: IInvoice) => (a.invoiceId < b.invoiceId) ? 1 : ((b.invoiceId < a.invoiceId) ? -1 : 0));
               this.invoices = invoices;

               let thisMonthYear = ((new Date().getMonth() + 1).toString() + new Date().getFullYear()).toString();
               if(thisMonthYear.length === 5){
                    thisMonthYear = "0" + thisMonthYear;
               }
               if(!this.isThisBillCycle(this.invoices[0].billCycle)){
                    
                    const thisMonthNotProcessesInvoice: IInvoice = {invoiceId:"0", billCycle: thisMonthYear, 
                    status:"Open", outstandingAmount:"0.00", totalAmount:0, checkRef:"", createDate: "",
                    invoiceType:"Invoice", paidInFull:"Unpaid"};

                    this.invoices.unshift(thisMonthNotProcessesInvoice);

               }else{
                    //We should never really need to do this for the current month. 
                    //because we should have have the current month in the list return, because it is not processed.
                    //but just incase. lets clean it up.
                    this.invoices[0].status = "Open";
                    this.invoices[0].paidInFull = "Unpaid";
                    this.invoices[0].totalAmount = 0;
                    this.invoices[0].outstandingAmount = "0.00";
               }


               if(this.invoices.length > 4){
                    this.invoices = this.invoices.splice(0, 4);
               }


               const dueCount = this.invoices.filter(i => i.paidInFull === "Unpaid" && this.isThisBillCycle(i.billCycle) === false) || null;
               if(dueCount === null || dueCount.length <= 1){
                    this.showPayAll = false;
               }else{
                    this.showPayAll = true;
               }
          } else {
               this.invoices = [];
          }
          this.totalBalance = this.invoices.reduce((a, curr) => a + parseFloat(curr.outstandingAmount), 0);
          this.isPaying = false;


     }

     get CdbBillingReportsLink() {
          return environment?.APP_CDB_URL;
     }


     //#region "Formatting"
     formatDate(date: Date) {
          //return moment(date).format('MM/DD/YYYY');
     }

     formatMoney(amount: number) {
          const formatter = new Intl.NumberFormat('en-US', {
               style: 'currency',
               currency: 'USD'
          });
          return formatter.format(amount);
     }
     updateNumberFormat() {
          let formattedNumber = this.formatMoney(parseFloat(this.paymentAmount.replace("$", ""))).toString();
          if (formattedNumber.includes("NaN")) {
               formattedNumber = "$0.00";
          }
          this.paymentAmount = formattedNumber;
     }

     formatBillCycle(billCycle: string): string {
          if (billCycle.length === 6) {
               return billCycle.substr(0, 2) + '/' + billCycle.substr(2, 4);
          } else {
               return billCycle;
          }
     }

     isThisBillCycle(billCycle: string): boolean {
          let thisMonthYear = ((new Date().getMonth() + 1).toString() + new Date().getFullYear()).toString();
          if(thisMonthYear.length === 5){
               thisMonthYear =  "0" + thisMonthYear;
          }
          if (billCycle.length === 6) {
               return (billCycle.substr(0, 2) + billCycle.substr(2, 4)) === thisMonthYear;
          } else {
               return billCycle === thisMonthYear;
          }
     }

     //#endregion


     //#region "Payment Window"
     openPaymentWindow(invoice: IInvoice) {
          this.selectedInvoice = invoice;
          this.selectedInvoicesIds = invoice.invoiceId
          this.paymentAmount = "$" + this.selectedInvoice.outstandingAmount;
          this.paymentAmountMax = parseFloat(this.selectedInvoice.outstandingAmount);
          this.creatingPayment = true;
          this.scrollToPayment();
     }

     openPaymentWindowAll() {
          this.selectedInvoice = null;
          this.selectedInvoicesIds = "";
          let payAmount = 0.0;
          this.invoices.forEach((pm: IInvoice) => {
               if (parseFloat(pm.outstandingAmount) > 0) {
                    this.selectedInvoicesIds += pm.invoiceId + ", ";
                    payAmount += parseFloat(pm.outstandingAmount);
               }
          });
          if (this.selectedInvoicesIds.endsWith(', ')) {
               this.selectedInvoicesIds = this.selectedInvoicesIds.substring(0, this.selectedInvoicesIds.length - 2);
          }
          this.paymentAmount = this.formatMoney(payAmount);
          this.paymentAmountMax = payAmount;
          this.creatingPayment = true;
          this.scrollToPayment();

     }

     closePaymentWindow() {
          this.creatingPayment = true;
          setTimeout(() => this.scrollToTop(), 500);
          return false;
     }

     closeCreatingPayment() {
          this.creatingPayment = false;
          setTimeout(() => this.scrollToTop(), 500);
          return false;
     }


     payNow() {
          this.invoicesToPay = [];
          this.displayPaymentDetails = [];
          this.balance = 0;
          if (this.selectedInvoice !== null) {
               this.invoicesToPay.push(this.selectedInvoice);
          } else {
               this.invoicesToPay = this.invoices
          }

          this.paymentRequest = {
               billingAccountId: this.selectedMethodId,
               invoices: []
          }

          let invoiceList: string = "";
          let amount = parseFloat(this.paymentAmount.replace("$", ""));
          this.invoicesToPay.forEach(element => {
               if (parseFloat(element.outstandingAmount) > 0) {
                    this.totalDueForBill += parseFloat(element.outstandingAmount)
                    if (amount >= parseFloat(element.outstandingAmount)) {
                         const amountToApplyToInvoice = parseFloat(element.outstandingAmount);
                         this.totalAmountPaying += amountToApplyToInvoice;
                         amount -= amountToApplyToInvoice;
                         this.paymentRequest!.invoices.push({ amountToPay: amountToApplyToInvoice, invoiceTotal: element.totalAmount, invoiceId: parseInt(element.invoiceId) });
                         this.displayPaymentDetails.push({ amountToPay: amountToApplyToInvoice, invoiceId: parseInt(element.invoiceId), balance: 0, startingBalance: parseFloat(element.outstandingAmount) });
                         invoiceList += element.invoiceId + ":" + amountToApplyToInvoice
                    } else {
                         const amountToApplyToInvoice = amount;
                         this.totalAmountPaying += amountToApplyToInvoice;
                         amount = 0;
                         const remainingBalance = parseFloat(element.outstandingAmount) - amountToApplyToInvoice
                         this.paymentRequest!.invoices.push({ amountToPay: amountToApplyToInvoice, invoiceTotal: element.totalAmount, invoiceId: parseInt(element.invoiceId) });
                         this.displayPaymentDetails.push({ amountToPay: amountToApplyToInvoice, invoiceId: parseInt(element.invoiceId), balance: remainingBalance, startingBalance: parseFloat(element.outstandingAmount) });
                         invoiceList += element.invoiceId + ":" + amountToApplyToInvoice
                    }
               }
          });
          this.balance = this.totalDueForBill - this.totalAmountPaying;

          this.modalService.open(this.confirmPayRef, { ariaLabelledBy: 'confirmPayModalTitle' });
     }

     cancelPayment() {
          this.displayConfirmPay = false;
          this.creatingPayment = false;
          this.clearPaymentInfo();
          this.modalService.dismissAll();
          setTimeout(() => this.scrollToTop(), 500);
     }

     private clearPaymentInfo() {
          this.totalAmountPaying = 0;
          this.paymentRequest = null;
          this.invoicesToPay = [];
          this.totalDueForBill = 0;
          this.displayPaymentDetails = [];
          setTimeout(() => this.scrollToTop(), 500);
     }

     getPaymentString(key: string) {
          let text = this.generalService.getTranslation(key, 'invoice')
          text = text.replace("XXX.XX", this.formatMoney(this.totalAmountPaying));
          text = text.replace((this.paymentIsCard() ? "/ACH" : "credit card/"), "");
          const findPayment = this.displayMethods.find((p: any) => p!.methodId === this.selectedMethodId!)

          text = text.replace("#1234#", findPayment!.accountNumber);
          return text;
     }
     
     paymentSuccess(key: string) {
          let text = this.generalService.getTranslation(key, 'invoice')
          if(this.userProfile?.customer.billingInfo && this.userProfile?.customer.billingInfo.contactEmailId && 
               this.userProfile?.customer.billingInfo.contactEmailId!.toLocaleLowerCase() === this.userProfile?.primaryContactEmail!.toLocaleLowerCase()){
               //if we dont have a billing user or the billing users email is the same as the power user. we only send out one email.
               text = text.replace(" and primary@theircoemail.com","");
               text = text.replace(" y primary@theircoemail.com","");
               text = text.replace("you@youremail.com", this.userProfile?.userData.email!);
          }else{
               text = text.replace("you@youremail.com", this.userProfile?.userData.email!);
               text = text.replace("primary@theircoemail.com", this.userProfile?.primaryContactEmail!);
          }
          return text;
     }

     showPrimaryEmail() {
          if (this.userProfile?.userData?.email && this.userProfile?.primaryContactEmail &&
               this.userProfile?.userData!.email !== this.userProfile?.primaryContactEmail!) {
               return true;
          } else {
               return false;
          }
     }

     paymentIsCard() {
          const findPayment = this.displayMethods.find((p: any) => p!.methodId === this.selectedMethodId!)
          return findPayment?.isCC
     }
     //#endregion

     //#region "server calls"
     newPayment() {
          this.modalService.dismissAll();
          this.paymentId = 0;
          this.isPaying = true;
          this.displayConfirmPay = false;
          const findPayment = this.displayMethods.find((p: any) => p!.methodId === this.selectedMethodId!)
          this.invoiceService.pay(this.paymentRequest!, this.selectedMethodId, findPayment!.isCC, findPayment!.accountNumber, this.balance.toString()).subscribe((result: number) => {
               if (result > 0) {
                    this.showPaymentSuccess = 15;
                    this.paymentId = result;
                    this.modalService.open(this.successRef, { ariaLabelledBy: 'successModalTitle' });
               } else {
                    this.showPaymentError = 120;
                    this.modalService.open(this.errorRef, { ariaLabelledBy: 'errorModalTitle' });
               }
               this.creatingPayment = false;
               this.clearPaymentInfo();
               const invoicePromise = this.invoiceService.getInvoices();
               invoicePromise.subscribe((result: IInvoice[] | any) => this.loadInvoices(result));
          });
     }

     closeSuccess() {
          this.showPaymentSuccess = 0;
          this.modalService.dismissAll();
          setTimeout(() => this.scrollToTop(), 500); this.scrollToTop();
     }

     closeError() {
          this.showPaymentError = 0
          this.modalService.dismissAll();
          setTimeout(() => this.scrollToTop(), 500);
     }

     download(invoiceId: number, cycleId:string) {
          this.isDownloading = true;
          const userProfile_ = localStorage.getItem('userprofile');
          const userProfile = JSON.parse(userProfile_!) as UserProfile;
          this.invoiceService.GetInvoicePdfById(Number(userProfile.customer.customerId), Number(invoiceId)).subscribe((result: any) => {
               const filename = `Invoice-${cycleId}.pdf`;
               const element = document.createElement('a');
               element.setAttribute('href', 'data:application/octet-stream;base64,' + result);
               element.setAttribute('download', filename);
               element.style.display = 'none';
               document.body.appendChild(element);
               element.click();
               document.body.removeChild(element);
               this.isDownloading = false;
          });
     }

     loadBillingAccounts(billingAccounts: PaymentMethods | any) {
          if (billingAccounts) {
               this.activeMethods.creditCards = billingAccounts.creditCards.filter((item: PaymentMethodCc) => item.isActive);
               this.activeMethods.creditCards.forEach((cc: PaymentMethodCc) => {

                    this.displayMethods.push({ isCC: true, accountNumber: cc.creditCardNumber, methodId: cc.id, isDefault: cc.isDefault });
                    if (cc.isDefault) {
                         this.selectedMethodId = cc.id;
                    }
               });
               if (this.selectedMethodId === 0 && this.displayMethods.length > 0) {
                    this.selectedMethodId = this.displayMethods[0].methodId;
               }

               this.activeMethods.bankAccounts = billingAccounts.bankAccounts.filter((item: PaymentMethodAch) => item.isActive);
               this.activeMethods.bankAccounts.forEach((ach: PaymentMethodAch) => {
                    this.displayMethods.push({ isCC: false, accountNumber: ach.acctNo, methodId: ach.id, isDefault: ach.isDefault });
                    if (ach.isDefault) {
                         this.selectedMethodId = ach.id;
                    }
               });
          } else {
               this.paymentMethods = [];
          }
          this.isLoading = false;
     }



     //#endregion




     scrollToPayment() {
          const targetElement = this.elementRef.nativeElement.querySelector('#creatingPaymentBox');
          targetElement.scrollIntoView({ behavior: 'smooth' });
     }
}
